import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/carlosdata/nuxtwp/nuxtwp/layouts/default.vue").then(m => m.default || m))
}